module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_foreword",
      "id": "tocf"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_preface",
      "id": "tocp"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_chap1#c1",
      "id": "toc1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("1:")]), _vm._v("The Crisis of Catholic Education: A History with a Lesson")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap2#c2",
      "id": "toc2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("2:")]), _vm._v("The Schools and Our Children: No Passing Grade")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap3#c3",
      "id": "toc3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("3:")]), _vm._v("The Purposes of Education: Happiness, Culture, Virtue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap4#c4",
      "id": "toc4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("4:")]), _vm._v("The Methods of the Teacher: Imitation before Invention")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap5#c5",
      "id": "toc5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("5:")]), _vm._v("The Matter of Learning: The Sprightly Seven Arts")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap6#c6",
      "id": "toc6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum"
  }, [_vm._v("6:")]), _vm._v("The Coming Renewal: Faith in the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_appendix1",
      "id": "toca1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Discussion Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_appendix2",
      "id": "toca2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: Guide to Further Study")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_endnotes",
      "id": "tocn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-355d9dfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_contents.vue
// module id = 66
// module chunks = 0